




import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  setup() {
    const textRef = ref<HTMLDivElement | null>(null)

    onMounted(() => {
      // wrap all tables in a <div> and set the maximum width of the table
      if (textRef.value) {
        const wrapper = textRef.value.querySelector('.cst-protocol-wrapper')

        const wrapperTables = wrapper?.querySelectorAll('table')
        wrapperTables?.forEach((element) => {
          const elementContent = element

          const newWrapper = document.createElement('div')
          element.replaceWith(newWrapper)

          newWrapper.style.overflow = 'auto'
          newWrapper.appendChild(elementContent)
        })
      }
    })

    return { textRef }
  },
})
